import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';
import kycReducer from './slices/kyc/kycSlice';
import allusersReducer from './slices/allusers/allusersSlice';
import riskprofileReducer from './slices/riskprofile/riskprofileSlice';
import orderbookReducer from './slices/orderbook/orderbookSlice';
import dashboardReducer from './slices/dashboard/dashboardSlice';
import subscriptionReducer from './slices/subscription/subscriptionSlice';
import { apiSlice } from './api/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    kyc: kycReducer,
    allusers: allusersReducer,
    riskprofile: riskprofileReducer,
    orderbook: orderbookReducer,
    dashboard: dashboardReducer,
    subscription: subscriptionReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});
